import { render, staticRenderFns } from "./BundleSummaryStats.vue?vue&type=template&id=72d877be"
import script from "./BundleSummaryStats.vue?vue&type=script&lang=js"
export * from "./BundleSummaryStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports